
import { getCurrentUser } from '@nextcloud/auth'
import { generateUrl } from '@nextcloud/router'

const encodeFilePath = function(path) {
	const pathSections = (path.startsWith('/') ? path : `/${path}`).split('/')
	let relativePath = ''
	pathSections.forEach((section) => {
		if (section !== '') {
			relativePath += '/' + encodeURIComponent(section)
		}
	})
	return relativePath
}

const isPublic = function() {
	return !getCurrentUser()
}

const getToken = function() {
	return document.getElementById('sharingToken') && document.getElementById('sharingToken').value
}

// preview width generation
const previewWidth = 256

export default {
	name: 'NewMessageTemplatePreview',
	inheritAttrs: false,

	props: {
		basename: {
			type: String,
			required: true,
		},

		checked: {
			type: Boolean,
			default: false,
		},

		fileid: {
			type: [String, Number],
			required: true,
		},

		filename: {
			type: String,
			required: true,
		},

		previewUrl: {
			type: String,
			default: null,
		},

		hasPreview: {
			type: Boolean,
			default: true,
		},

		mime: {
			type: String,
			required: true,
		},

		ratio: {
			type: Number,
			default: null,
		},
	},

	emits: ['check'],

	data() {
		return {
			failedPreview: false,
		}
	},

	computed: {
		/**
		 * Strip away extension from name
		 *
		 * @return {string}
		 */
		nameWithoutExt() {
			return this.basename.includes('.') ? this.basename.split('.').slice(0, -1).join('.') : this.basename
		},

		id() {
			return `template-picker-${this.fileid}`
		},

		realPreviewUrl() {
			// If original preview failed, fallback to mime icon
			if (this.failedPreview && this.mimeIcon) {
				return this.mimeIcon
			}

			if (this.previewUrl) {
				return this.previewUrl
			}
			// TODO: find a nicer standard way of doing this?
			if (isPublic()) {
				return generateUrl(`/apps/files_sharing/publicpreview/${getToken()}?fileId=${this.fileid}&file=${encodeFilePath(this.filename)}&x=${previewWidth}&y=${previewWidth}&a=1`)
			}
			return generateUrl(`/core/preview?fileId=${this.fileid}&x=${previewWidth}&y=${previewWidth}&a=1`)
		},

		mimeIcon() {
			return OC.MimeType.getIconUrl(this.mime)
		},
	},

	methods: {
		onCheck() {
			this.$emit('check', this.fileid)
		},

		onFailure() {
			this.failedPreview = true
		},
	},
}
